import { Interactor } from "@anna-money/anna-web-ui";
import classNames from "classnames";
import { type FC, type HTMLAttributeAnchorTarget, type ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

import { Text, type TextProps } from "components/Text/Text";
import styles from "./Link.module.scss";

type LinkProps = {
  href?: string;
  weight?: TextProps["weight"];
  size?: TextProps["size"];
  className?: string;
  onClick?: () => void;
  target?: HTMLAttributeAnchorTarget;
  rel?: string;
  children?: ReactNode;
};

export const Link: FC<LinkProps> = ({
  href,
  weight = "regular",
  size = "m",
  target,
  rel,
  className: classNameProp,
  children,
  onClick,
}) => {
  const className = classNames(styles.link, classNameProp);
  const linkRel = rel ?? (target === "_blank" ? "noopener noreferrer" : undefined);
  const text = (
    <Text size={size} weight={weight} tag="span">
      {children}
    </Text>
  );
  return href ? (
    <RouterLink className={className} to={href} target={target} rel={linkRel}>
      {text}
    </RouterLink>
  ) : (
    <Interactor
      className={className}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {text}
    </Interactor>
  );
};
